var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-component-wrapper"},[_c('grid',{attrs:{"config":_vm.gridConfig}}),_c('modal-new',{attrs:{"config":{id: _vm.gridConfig.id, api: 'CompanyRemarkSubjects/Get/'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }